const TONES = {
  success: "bg-green-100 text-green-800 border-green-200",
  warning: "bg-amber-100 text-amber-900 border-amber-200",
  danger: "bg-red-100 text-red-800 border-red-200",
  info: "bg-blue-100 text-blue-800 border-blue-200",
  purple: "bg-violet-100 text-violet-800 border-violet-200",
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
};

export const StatusBadge = ({ label, tone = "neutral", testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${TONES[tone] || TONES.neutral}`}>
    {label}
  </span>
);

export const MapBadge = ({ map, value, testId }) => {
  const s = map[value] || { label: value, tone: "neutral" };
  return <StatusBadge label={s.label} tone={s.tone} testId={testId} />;
};
